
const getLoanMarkingAccounts = (markingAction) => {
  if (typeof markingAction !== "string") return [];

  return markingAction
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);
};

export const hasLoanMarkingIssue = (loan) => {
  if (!loan?.marking || !loan?.markingAction) return false;

  const markedLoans = getLoanMarkingAccounts(loan.markingAction);

  return markedLoans.includes(loan.loanAccountNumber);
};


export const hasAuditedIssue = (loan, CHECK_LOAN_MARKINGS) => {
  if (!loan?.audited || !loan?.auditedAction) return false;

  // assuming auditedAction is always an array
  if (!Array.isArray(loan.auditedAction)) return false;

  return loan.auditedAction.some((action) =>
    [
      CHECK_LOAN_MARKINGS.spuriousGold,
      CHECK_LOAN_MARKINGS.unacceptableItem,
    ].includes(action)
  );
};

export const getLoansWithCommonIssues = (
  denialKey,
  loansData = [],
  CHECK_LOAN_MARKINGS
) =>
  loansData
    .map((loan) => {
      if (
        hasLoanMarkingIssue(loan, CHECK_LOAN_MARKINGS) ||
        hasAuditedIssue(loan, CHECK_LOAN_MARKINGS)
      ) {
        return {
          loanAccountNumber: loan.loanAccountNumber,
          denialKey,
        };
      }
      return null;
    })
    .filter(Boolean);

export const getDenialMessage = (
  denialReason,
  loanData,
  type,
  denialReasonsList,
  CHECK_LOAN_MARKINGS
) => {
  if (!denialReason) return "";

  // Loan-wise reason
  if (denialReasonsList?.loanwise?.[denialReason]) {
    return denialReasonsList.loanwise[denialReason];
  }

  // Customer-wise reason → append loan numbers
  if (denialReasonsList?.custIdWise?.[denialReason]) {
    const commonLoans = getLoansWithCommonIssues(
      denialReason,
      loanData,
      CHECK_LOAN_MARKINGS
    );

    const loanNumbers = commonLoans
      .map((item) => item.loanAccountNumber)
      .join(", ");

    return `${denialReasonsList.custIdWise[denialReason]} (Loan: ${loanNumbers})`;
  }

  return `You are not eligible for ${type}`;
};
